export default __webpack_public_path__ + "static/media/AccountManager.ad2057ec.svg";